import {useParams} from "react-router-dom";
import {useContext, useEffect, useState} from "react";
import {authContext} from "../../../context/auth";
import Spinner from "../../Spinner";
import Error from "../../Alerts/Error";
import Job from "./Job";
import filterResponse from "../../../filterResponse";
import {onJobClosed} from "../../../jobClosed";
import {ProgressProvider} from "../../../context/progress";

export default function CheckJob() {
	const {id} = useParams();
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [job, setJob] = useState(null);

	const {user} = useContext(authContext);

	// The job can close while the page is open. Whichever request finds that out first ends up here,
	// and showing the message in place of the job is what actually stops the work: the tabs, the
	// upload widgets and the recorder all go away with it.
	useEffect(() => {
		return onJobClosed(message => {
			setError(message);
			setJob(null);
			setLoading(false);
		});
	}, []);

	useEffect(() => {
		setLoading(true);
		setJob(null);
		setError(null);

		(async () => {
			try {
				const response = await fetch(process.env.REACT_APP_ENDPOINT + '/crowdJobs/' + id, {
					method: "GET",
					credentials: "include"
				});
				await filterResponse(response);

				if (response.status === 200) {
					const {crowdJob} = await response.json();
					setJob(crowdJob);
				}
				else if (response.status === 404) {
					setError("This job doesn't exist.");
				}
				else if (response.status === 409) {
					setError((await response.json()).error);
				}
				else {
					throw new Error("Wrong status code.");
				}
			}
			catch (e) {
				console.error(e);
				setError("Failed to check if this job is available.");
			}
			finally {
				setLoading(false);
			}
		})();
	}, [id]);

	if (loading) {
		return (
			<div className={"shadow-sm border p-3 bg-white m-3 container mx-auto"}>
				<Spinner />
			</div>
		);
	}
	if (error) {
		return (
			<div className={"shadow-sm border p-3 bg-white m-3 container mx-auto"}>
				<Error message={error} />
			</div>
		)
	}
    if (!user.paypal && !user.lspId) {
        return (
			<div className={"shadow-sm border p-3 bg-white m-3 container mx-auto"}>
				<Error message={<p>Please add a paypal account to your profile before starting. You can do this by going to <a href="https://freelancer.datamundi.space/profile/payment">My Profile {">"} Payment</a> page in Freelancer portal.</p>} />
			</div>
        )
    }
	if (job) {
		return (
			<ProgressProvider>
				<Job job={job} />
			</ProgressProvider>
		);
	}
}
